import { render, staticRenderFns } from "./large-text-area.vue?vue&type=template&id=f53fffbc"
import script from "./large-text-area.vue?vue&type=script&lang=js"
export * from "./large-text-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports